module.exports = __webpack_public_path__ + "img/commodity2.402d421d.png";